import React from 'react';
import ModalFrame from '../../ModalFrame';
import GetAdvancedQuestionOptions from './GetAdvancedQuestionOptions';

class QuestionOptionsModalController extends React.Component {
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);
  }


  hideModal() {
    const {setModalInfo} = this.props;
    setModalInfo({});
  }

  render() {
    const {modalInfo, confirmHandler, cancelHandler} = this.props;
    return (
      <div className="example-modal">
        {modalInfo.name === 'createQuestionOptions' ?
          <ModalFrame
            title={`ADVANCED OPTIONS`}
            desktopWidth="750px"
            headerCloseButtonHandler={this.hideModal}
            hasHeader={true}>
            <GetAdvancedQuestionOptions
              modalInfo={modalInfo}
              hideModal={this.hideModal}
              confirmHandler={confirmHandler}
              cancelHandler={cancelHandler}
            />
          </ModalFrame> : null}
      </div>
    )
  }
}

export default QuestionOptionsModalController;